import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=31d9b30f&scoped=true&"
import script from "./EditOrder.vue?vue&type=script&lang=ts&"
export * from "./EditOrder.vue?vue&type=script&lang=ts&"
import style0 from "./EditOrder.vue?vue&type=style&index=0&id=31d9b30f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9b30f",
  null
  
)

export default component.exports